// @flow
import React from 'react'

import '../styles.scss'

const baseClass = 'loader'

const FormLoader = ({ className = '' }: Props) => (
  <div className={`${baseClass} ${className}`}>
    <div
      style={{
        paddingBottom: 14,
        borderBottom: '1px solid #ebeef0',
      }}
    >
      <div
        className="loader__row"
        style={{
          height: 30,
          width: 60,
          display: 'inline-block',
          marginRight: 25,
        }}
      />
      <div
        className="loader__row"
        style={{
          height: 30,
          width: 250,
          display: 'inline-block',
        }}
      />
    </div>
    <div
      className="loader__row"
      style={{
        height: 16,
        width: 60,
        marginTop: 24,
      }}
    />
    <div
      style={{
        borderBottom: '1px solid #ebeef0',
        paddingBottom: 16,
      }}
    >
      <div
        className="loader__row"
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          width: 136,
          height: 96,
          marginTop: 8,
        }}
      />
      <div
        style={{
          display: 'inline-block',
          height: 96,
          verticalAlign: 'middle',
        }}
      >
        <div
          className="loader__row"
          style={{
            width: 128,
            height: 32,
            marginTop: 20,
            marginLeft: 16,
          }}
        />
        <div
          className="loader__row"
          style={{
            width: 300,
            height: 16,
            marginTop: 15,
            marginLeft: 16,
          }}
        />
      </div>
    </div>
    <div
      style={{
        paddingBottom: 16,
        borderBottom: '1px solid #ebeef0',
      }}
    >
      <div
        className="loader__row"
        style={{
          height: 16,
          width: 100,
          marginTop: 16,
        }}
      />
    </div>
    <div
      className="loader__row"
      style={{
        width: 80,
        height: 16,
        marginTop: 22,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: '100%',
        height: 16,
        marginTop: 6,
        marginBottom: 16,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: '60%',
        height: 16,
        marginTop: 6,
        marginBottom: 16,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: '70%',
        height: 16,
        marginTop: 6,
        marginBottom: 16,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: '92%',
        height: 16,
        marginTop: 6,
        marginBottom: 16,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: 100,
        height: 16,
        marginTop: 36,
      }}
    />
    <div
      className="loader__row"
      style={{
        width: 242,
        height: 48,
        marginTop: 6,
        marginBottom: 24,
      }}
    />
    <div
      className="loader__row"
      style={{
        display: 'inline-block',
        width: 120,
        height: 40,
        marginRight: 8,
        borderRadius: 4,
      }}
    />
    <div
      className="loader__row"
      style={{
        display: 'inline-block',
        width: 120,
        height: 40,
        borderRadius: 4,
      }}
    />
  </div>
)

export default FormLoader
